import React from "react"
import { answerOptionsListShape } from "utils/propTypeShapes"
import { redirectTo, answerOptionsListEditPath } from "utils/routeHelpers"
import { CircularIconButton } from "shared/buttons"
import ItemRow from "shared/ItemRow"

const AnswerOptionsList = ({ answerOptionsList }) => (
  <ItemRow
    collapsable
    itemRowHeaderContent={(
      <span>{answerOptionsList.name}</span>
    )}
    itemRowHeaderControls={(
      <CircularIconButton
        ariaLabel={`edit ${answerOptionsList.name}`}
        icon="pencil"
        onClick={() => redirectTo(answerOptionsListEditPath(answerOptionsList.id))}
      />
    )}
    itemRowBody={(
      <div className="overflow-y-auto max-h-72 thin-scrollbar transparent-scroll-track">
        {
          answerOptionsList.options.map((option) => (
            <ItemRow
              key={`answerOption-${option}`}
              className="dark"
              itemRowHeaderContent={<span>{option}</span>}
            />
          ))
        }
      </div>
    )}
  />
)

AnswerOptionsList.propTypes = {
  answerOptionsList: answerOptionsListShape.isRequired,
}

export default AnswerOptionsList
